export enum EnumEstadoCiclo {
  Iniciado = 1,
  PdteValidarListado,
  Procesando,
  PdteValidarFacturas,
  Finalizado,
  Anulado
}
